import styled from 'styled-components'

import Button from 'components/button'
import mediaQueries from 'components/media-queries'
import theme from 'components/theme'
import e2eClasses from 'helpers/automation'

export const Container = styled.div.attrs(() => ({
  className: e2eClasses('corporate.refundContainer')
}))`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme, color }) => theme.colors[color] || theme.colors.alabaster};

  ${mediaQueries.mobile`
    text-align: center;
  `}
`

export const ResponseImage = styled.img.attrs(props => ({
  className: e2eClasses('corporate.refundImage'),
  src: props.src
}))`
  display: flex;
  height: 270px;
  width: 100%;
  transform: ${({ flip }) => (flip ? 'scaleX(-1)' : 'none')};
  ${({ error }) => !error && 'margin-top: -24px;'};

  ${mediaQueries.mobile`
    ${({ error }) => error && 'margin-top: -59px;'};
  `}
`
export const ButtonContainer = styled.div.attrs(() => ({
  className: e2eClasses('corporate.refundHomeButton')
}))`
  display: flex;
  flex-direction: ${props => (props.flexDirection ? 'row' : 'column')};
  gap: 8px;
  padding: 25px 0;

  ${mediaQueries.mobile`
    padding-bottom: 16px;
  `}
`

export const Title = styled.h1.attrs(() => ({
  className: e2eClasses('corporate.refundTitle')
}))`
  font-size: 18px;
  line-height: 1.28;
  margin-top: 16px;
  margin-bottom: 8px;
  color: ${({ theme }) => theme.colors.blue};
  font-family: ${({ theme }) => theme.fonts.semiBold};

  ${mediaQueries.mobile`
    font-size: 16px;
    padding: 0 25px;
  `}
`

export const Description = styled.p.attrs(() => ({
  className: e2eClasses('corporate.refundDescription')
}))`
  text-align: center;
  font-size: 14px;
  white-space: pre-line;
  color: ${props => (props.textGray ? theme.colors.doveGray : theme.colors.black)};
  font-family: ${({ theme }) => theme.fonts.regular};

  a {
    color: ${({ theme }) => theme.colors.blue50};
    text-decoration: underline;
  }

  ${mediaQueries.mobile`
    font-size: 12px;
    padding: 0 25px;
  `}
`

export const ButtonSecondary = styled(Button)`
  background-color: ${props => (props.secondaryButtonGray ? 'gray' : 'white')};
  color: ${props => (props.secondaryButtonGray ? 'white' : theme.colors.blue)};
`
